import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { usePage } from '@inertiajs/react';
import collect from 'collect.js';
const useAuth = () => {
    const page = usePage();
    const roles = collect(page.props.auth?.roles).keys();
    const permissions = collect(page.props.auth?.permissions);
    const can = (permission) => {
        if (typeof permission === 'string') {
            permission = [permission];
        }
        return permissions.intersect(permission).count() > 0;
    };
    const cannot = (permission) => {
        return !can(permission);
    };
    const is = (role) => {
        if (typeof role === 'string') {
            role = [role];
        }
        return roles.intersects(role).count() > 0;
    };
    const canRender = (permission, render) => {
        return can(permission) ? _jsx(_Fragment, { children: render }) : null;
    };
    return { can, cannot, is, canRender };
};
export default useAuth;
